import React, { useState} from "react";
import { Link } from "react-router-dom";
import useFetch from '../../../../commons/useFetch'
function New() {
    const [visibleEventNews, setVisibleEventNews] = useState(3)
    const [visiblePaperNews, setVisiblePaperNews] = useState(3)
    const { data: News } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/News');

    const showMoreEventNews=()=>{
        setVisibleEventNews(preValue => preValue + 3)
    }
    const showMorePaperNews = () => {
        setVisiblePaperNews(preValue => preValue + 3)
        
    }
    return (
        <div className="news">
            <div className="eventNews newsBox">
                <div className="container">
                    <h5 className="titleNew">
                        Tin sự kiện
                    </h5>
                    {
                        News.filter(i => i.news_type === "EVN").splice(0, 1).map((item) => {
                            return (
                                <div className="row newsActive">
                                    <div className="col-lg-8 col-12 col-md-6">
                                        <div className="imgBox">
                                            <img className="img-fluid" src={item.image} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12 col-md-6" >
                                        <div className="contentbox">
                                            <div className="title">
                                                <Link to={`/news/${item.id}?${item.title}`}>{item.title}</Link>
                                            </div>
                                            <div className="time">{item.time}</div>
                                            <div className="textContent">
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        )
                    }
                    <div className="row newsList">
                        {
                            News.filter(i => i.news_type === "EVN").splice(1, visibleEventNews).map(item => {
                                return (
                                <div className="col-lg-4  col-12 col-md-4">
                                    <div className="imgBox">
                                        <img className="img-fluid" src={item.image} alt="" />
                                    </div>
                                    <div className="contentbox">
                                        <div className="title">
                                                <Link to={`/news/${item.id}?${item.title}`}>{item.title}</Link>
                                        </div>
                                        <div className="time">{item.time}</div>
                                        <div className="textContent">
                                            {item.description}
                                        </div>
                                    </div>
                                </div>
                                )
                            })
                        }
                    </div>
                    {visibleEventNews < News.filter(i => i.news_type === "EVN").length && <div className="loadMore" onClick={showMoreEventNews}>Xem thêm</div>}
                    
                </div>
            </div>
            <div className="paperNews">
                <div className="container">
                    <h5 className="titleNew">
                        Tin báo chí
                    </h5>
                    {
                        News.filter(i => i.news_type === "PPN").splice(0,1).map((item) => {
                            return (
                                <div className="row newsActive">
                                    <div className="col-lg-8 col-12 col-md-6">
                                        <div className="imgBox">
                                            <img className="img-fluid" src={item.image} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12 col-md-6">
                                        <div className="contentbox">
                                            <div className="title">
                                                <Link to={`/news/${item.id}?${item.title}`}>{item.title}</Link>
                                            </div>
                                            <div className="time">{item.time}</div>
                                            <div className="textContent">
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        )
                    }
                    <div className="row newsList">
                        {
                            News.filter(i => i.news_type === "PPN").splice(1, visiblePaperNews).map(item => {
                                return (
                                    <div className="col-lg-4  col-12 col-md-4">
                                        <div className="imgBox">
                                            <img className="img-fluid" src={item.image} alt="" />
                                        </div>
                                        <div className="contentbox">
                                            <div className="title">
                                                <Link to={`/news/${item.id}?${item.title}`}>{item.title}</Link>
                                            </div>
                                            <div className="time">{item.time}</div>
                                            <div className="textContent">
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {visiblePaperNews < News.filter(i => i.news_type === "PPN").length && <div className="loadMore" onClick={showMorePaperNews}>Xem thêm</div>}
                    
                </div>
                
            </div>
        </div>
    )
}
export default New;